import { FC } from 'react';
import { CommonModal } from '../CommonModal';
import styles from '../../assets/scss/ConfirmModal/ConfirmVariantsDirtyModal.module.scss';
import { postMessageGtag } from '../../utils/trackClick';

export const ConfirmVariantsDirtyModal: FC<{
  active: boolean;
  closeFunc: () => void;
  clickLeavePageBtnFunc: () => void;
}> = ({ active, closeFunc, clickLeavePageBtnFunc }) => {
  if (!active) return null;

  // GAタグ
  const eventCategory = 'detailProducts';

  return (
    <CommonModal
      active={active}
      closeFunc={() => {
        closeFunc();
        postMessageGtag('click_modal_close_edit', eventCategory);
      }}
    >
      <div
        className={styles.title}
        style={{ marginTop: '36px' }}
      >
        お届け商品の変更が完了
        <span
          className={styles.title}
          style={{ display: 'inline-block' }}
        >
          していません。
        </span>
      </div>
      <div
        className={styles.text}
        style={{ marginTop: '16px' }}
      >
        ページを離れますか？
      </div>
      <div
        className={styles.btnSideContainer}
        style={{ marginTop: '48px' }}
      >
        <button
          className={styles.btnPrimary}
          onClick={() => {
            clickLeavePageBtnFunc();
            postMessageGtag('click_leave_edit', eventCategory);
          }}
        >
          ページを離れる
        </button>
        <button
          onClick={() => {
            closeFunc();
            postMessageGtag('click_continue_edit', eventCategory);
          }}
        >
          変更を続ける
        </button>
      </div>
    </CommonModal>
  );
};
